const onboardingTypes = {
  FETCHING: "FETCHING",
  SET_PLACES_SUGGESTION: "SET_PLACES_SUGGESTION",
  SET_HOTEL_AMENITIES: "SET_HOTEL_AMENITIES",
  SET_HOTEL_TYPES: "SET_HOTEL_TYPES",
  SET_ROOM_AMENITIES: "SET_ROOM_AMENITIES",
};

export default onboardingTypes;
